import { defineStore } from 'pinia'
import _ from 'lodash';
import { isLooseDeepEqual } from '../helpers/General';

export const useRouteHelperStore = defineStore('routeHelperStore', {
    state: () => (
        {
            saveAllowed : true,
            isDirty: true,
            show: false,
            to: null,
            initialState: {},
            // validate_against: {},
            disable_navigation: false,
            retry_timeout : null,
        }),
    actions: {
        setInitialState(data){
            this.saveAllowed = true;
            this.initialState = JSON.parse(JSON.stringify(data));
            this.validateData(data);
        },
        validateData(nowState){
            // this.validate_against = JSON.parse(JSON.stringify(nowState));
            if(isLooseDeepEqual(this.initialState, nowState)){
                this.isDirty = false;
            }else{
                this.isDirty = true;
            }
        }
    },
  })
